import DownloadReport from '../download-report';
import Filters from '../filters';
import ReportLegend from '../report-legend';
import StandardsPagination from '../standards-pagination';
import { Box, Flex, Text } from '@chakra-ui/react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useGetIsLeaderSuitFlag } from '@lon/shared/hooks';
import { SsStandardsAggregationTypeEnum } from '@lon/shared/requests';
import { ReportProps } from './../../duck/types';

interface Props {
  total: number;
  itemsPerPage: number;
  defaultLevel: string;
  reportProps?: ReportProps;
}

const Caption: React.FC<Props> = ({
  total,
  itemsPerPage,
  defaultLevel,
  reportProps,
}) => {
  const { t } = useTranslation();
  const isLeaderSuit = useGetIsLeaderSuitFlag();
  const [searchParams] = useSearchParams();

  const aggregateBy =
    searchParams.get('aggregateBy') ?? SsStandardsAggregationTypeEnum.Student;

  return (
    <Flex flexDir="column">
      <Flex px={8} py={4} justify="space-between" align="center">
        <Box display="flex" gap={2} alignItems="center">
          <Text variant="h5" color="primary.800" className="tr-skip">
            {t('reportsDashboard.standardsBy', {
              by:
                aggregateBy === SsStandardsAggregationTypeEnum.School
                  ? 'Schools'
                  : aggregateBy,
            })}
          </Text>
        </Box>
        <Flex gap={3}>
          {reportProps && isLeaderSuit ? (
            <DownloadReport reportProps={reportProps} />
          ) : null}
          <Filters defaultLevel={defaultLevel} />
          <ReportLegend />
        </Flex>
      </Flex>
      <Flex
        justifyContent={{ base: 'center', b768: 'flex-end' }}
        borderTop="1px solid"
        borderTopColor="secondary.200"
        py={0}
        px={0}
      >
        <StandardsPagination total={total} itemsPerPage={itemsPerPage} />
      </Flex>
    </Flex>
  );
};

export default Caption;
